export default {
  postureReport: "पोस्चर रिपोर्ट",
  postureData: "पोस्चर डेटा",
  postureDataContrast: "पोस्चर डेटा का कॉन्ट्रास्ट",
  postureRiskContrast: "पोस्चर रिस्क कॉन्ट्रास्ट",
  postureDataTrend: "पोस्चर डेटा ट्रेंड",
  postureRiskTrend: "पोस्चर रिस्क ट्रेंड",
  postureLogData: "मुद्रा लॉग डेटा",
  lateralhead: "पार्श्व मुख का झुकाव",
  unevenshoulder: "असमान कंधे",
  scoliosis: "स्कोलियोसिस",
  unevenhip: "कूल्हे का पार्श्विक झुकाव",
  xleg: "X-आकार का पैर",
  oleg: "O-आकार का पैर",
  roundedshoulder: "गोलाकार कंधा",
  kneehyperextension: "नुकीला घुटना",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "मुख आगे",
  toTheLeft: "(बाएं)",
  toTheRight: "(दाएं)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(नॉर्मल)",
  leg: "पैर",
  legLeft: "पैर (L)",
  legRight: "पैर (R)",
  riskAssessment: "रिस्क आंसेसमेंट",
  muscleState: "मस्कल का स्थिति",
  muscleStateDesc: "कोई असामान्य मस्कल स्थिति नहीं मिली",
  testTime: "टेस्ट टाइम",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "इटम",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "मोइरे छवि",
  lAbnormalRisk: "L जोखिम",
  mAbnormalRisk: "M जोखिम",
  hAbnormalRisk: "H जोखिम",
  highRisk: "उच्च जोखिम",
  riskAnalysis: "जोखिम विश्लेषण",
  conclusionRecommendation: "निष्कर्ष और सिफारिश",
  solution: "हल",
  movePosition: "बिंदु पर क्लिक करें ताकि स्थिति को स्थानांतरित कर सकें",
  confirmTheClose: "अभी तक नहीं बचाया गया, क्या आप बंद करने की पुष्टि करते हैं?",
  closeInfo: "अभी तक नहीं बचाया गया, क्या आप बंद करने की पुष्टि करते हैं?",
  share: "शेयर",
  front: "सामने",
  side: "पक्ष",
  back: "पीछे",
  otherSide: "दूसरा पक्ष",
  points: "बिंदु",
  angle: "कोण",
  name: "नाम",
  gender: "लिंग",
  male: "पुरुष",
  female: "महिला",
  age: "उम्र",
  year: "साल",
  height: "ऊंचाई",
  weight: "वजन",
  time: "समय",
  patientId: "रोगी आईडी",
  save: "सहेजें",
  saveModify: "सहेजें संशोधित",
  print: "मुद्रण",
  cancel: "रद्द करना",
  zoomIn: "ज़ूम इन",
  zoomOut: "ज़ूम आउट",
  ok: "ठीक है",
  return: "वापस",
  empty: "",
  unknown: "अज्ञात",
  succeedToCopy: "सफलतापूर्वक कॉपी किया गया",
  succeedToSave: "सफलतापूर्वक सहेजा गया",
  headForwardDistance: "सिर आगे की दूरी",
  pelvisForwardTilt: "कूल्हे का आगे झुकाव",
  wristHipDistanceLeft: "कलाई से कूल्हे की दूरी (बाएं)",
  wristHipDistanceRight: "कलाई से कूल्हे की दूरी (दाएं)",
  evaluator: "मूल्यांकनकरता",
  reportDate: "रपोर्ट की तारीख",
  introduction: "परिचय",
  doctorIntroDefault: "पशर कष्र: पुनरवासचकितस, मुद्रा मूलयंन और सुधार | अनुभव के वरष : 5 वर्ष सेअधक | विशषञा:खलोट पुनरवास, मुद्रा सुधार,दर्द प्रबंधन",
  recoveryLog: "पुनर्प्राप्ति लॉग",
  returnToReport: "रिपोर्ट पर लौटें",
  loading: "लोड हो रहा है...",
  showToolbox: "उपकरण बॉक्स दिखाएँ",
  hideToolbox: "उपकरण बॉक्स छिपाएँ",
};

